import { GRID_GUTTER } from './styles';

export const DEFAULT_SCROLL_CONFIG = {
  SMOOTH: true,
  OFFSET: -80 - GRID_GUTTER,
  DURATION: 300,
};
